import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import AddIcon from '@material-ui/icons/Add';

import TablePagination from '@material-ui/core/TablePagination';
import BRFab from '../../common-components/BRFab';

import * as stationsSearchFormReducer from '../reducer/stationsSearchForm';
import * as userReducer from '../../users-mgmt/reducer/userScreen';
import * as usersReducers from '../../users-mgmt/reducer';
import * as systemReducer from '../../system/reducer';

import * as stationsSearchFormAction from '../action-mgr/stationsSearchForm';
import * as stationsAction from '../action-mgr';

import SearchBox from '../../common-components/SearchBox';
import FlexOne from '../../common-components/FlexOne';

import { getStatusList } from '../constants';
import * as strings from '../../helpers/strings';

const styles = {
  root: {
    marginBottom: 20
  },
  dnone: {
    display: "none"
  },
  m0: {
    margin: '0px'
  },
}

const statusList = getStatusList();

class StationSearchForm extends Component {

  constructor() {
    super();

    this.handleOnSearchChange = this.handleOnSearchChange.bind(this);
    this.handleOnPageChange = this.handleOnPageChange.bind(this);
    this.handleSearchKeyDown = this.handleSearchKeyDown.bind(this);
    this.handleAddClick = this.handleAddClick.bind(this);
    this.handleStatusChange = this.handleStatusChange.bind(this);
  }

  componentDidMount() {
    this.handleOnPageChange(null, 0);
  }

  handleOnSearchChange(e) {
    const { setKeyword } = this.props;
    setKeyword(e.target.value);
  }

  handleOnPageChange(event, page) {
    const { pagination, stationName, search, status, getUser, users, loggedInUser  } = this.props;

    const parentUser = users.filter(usr => usr.id === getUser.parentId)

    search({
      keyword: stationName,
      userId: (parentUser.length > 0) ? parentUser[0].email : loggedInUser.email,
      startIndex: page,
      size: 30, //pagination.rowsPerPage
      status
    })
  }

  handleSearchKeyDown(e) {
    const { pagination, search, keyword, setStationName, status, getUser, users, loggedInUser } = this.props;
    const parentUser = users.filter(usr => usr.id === getUser.parentId)

    if ("Enter" === e.key) {
      search({
        keyword: keyword,
        userId: (parentUser.length > 0) ? parentUser[0].email : loggedInUser.email,
        startIndex: pagination.currentPage * 30, //pagination.rowsPerPage
        size: 30, //pagination.rowsPerPage
        status
      });
      setStationName(keyword);
    }
  }

  handleAddClick() {
    const { addNewStation, history } = this.props;
    addNewStation();
    history.push("/stations/new");
  }

  handleStatusChange = event => {
    const { keyword, setKeyword } = this.props;

    var status = event.target.value;
    this.props.setStatus(status);
    setKeyword(keyword);
    setTimeout(() => this.handleOnPageChange(null, 0), 100);
  }

  render() {
    const { keyword, classes, pagination, visibleAddBtn = true, status } = this.props;

    return (
      <div className={classes.root}>
        <Grid container alignItems="center">
          <Grid item md={3} sm={6} xs={12}>
            <SearchBox
              value={keyword}
              onChange={this.handleOnSearchChange}
              onKeyDown={this.handleSearchKeyDown}
              placeholder={strings.plaecholderTypeStationName}
              fullWidth={true}
            />
          </Grid>
          &nbsp;
          <FormControl variant={strings.txtOutlined}>
            <InputLabel htmlFor={strings.idSelectStatus}>{strings.lblStatus}</InputLabel>
            <Select
              value={status}
              onChange={this.handleStatusChange}
              input={
                <OutlinedInput
                  labelWidth={50}
                  name={strings.idSelectStatus}
                  id={strings.idSelectStatus}
                />
              }
            >
              {statusList.map(statusObj => <MenuItem key={statusObj.value} value={statusObj.value}>{statusObj.name}</MenuItem>)}
            </Select>
          </FormControl>
          <FlexOne />
          {visibleAddBtn && <BRFab onClick={this.handleAddClick}><AddIcon /></BRFab>}

          <span style={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.54)' }}> Total Page: {pagination.currentPage + 1} - {pagination.totalPage} </span>
          <TablePagination
            component="div"
            classes={{
              caption: classes.dnone,
              actions: classes.m0,
            }}
            count={pagination.totalRecord}
            rowsPerPage={30} //pagination.rowsPerPage
            page={pagination.currentPage}
            backIconButtonProps={{
              'aria-label': strings.lblPreviousPage,
            }}
            nextIconButtonProps={{
              'aria-label': strings.lblNextPage,
            }}
            rowsPerPageOptions={[30]} //pagination.rowsPerPage
            onChangePage={this.handleOnPageChange}
          />
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  keyword: stationsSearchFormReducer.getKeyword(state),
  stationName: stationsSearchFormReducer.getStationName(state),
  pagination: stationsSearchFormReducer.getPagination(state),
  status: stationsSearchFormReducer.getStatus(state),

  getUser: userReducer.getUser(state),
  users: usersReducers.getUsers(state),

  loggedInUser: systemReducer.getLoggedInUser(state),
});

const mapActionToProps = {
  setStatus: stationsSearchFormAction.setStatus,
  setKeyword: stationsSearchFormAction.setKeyword,
  search: stationsAction.search,
  setStationName: stationsSearchFormAction.setStationName,
  addNewStation: stationsAction.addNewStation
};

export default connect(mapStateToProps, mapActionToProps)(
  withStyles(styles)(
    withRouter(StationSearchForm)
  )
);